import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { UIHeading1 } from '@cian/ui-kit';
import cn from 'clsx';
import * as React from 'react';

import { Card } from './Card';
import about2 from './static/graph-screen.svg';
import about3 from './static/info-screen.svg';
import about1 from './static/val-screen.svg';
import * as styles from './styles.css';

interface IAboutReportProps {
  className?: string;
  onItemClick?(): void;
  onView(): void;
}

export const AboutReport: React.VFC<IAboutReportProps> = ({ className, onItemClick, onView }) => {
  return (
    <ActionAfterViewObserver callback={onView} callbackDelay={1500} wrapper={false} percentVisible={0.2}>
      <div className={cn(styles['container'], className)} data-name="about_report">
        <UIHeading1>Что будет в отчёте</UIHeading1>
        <Card title="Средняя оценка и диапазон цен" picSrc={about1} onClick={onItemClick} />
        <Card title="График изменения цены" picSrc={about2} onClick={onItemClick} />
        <Card title="Информация о доме" picSrc={about3} onClick={onItemClick} />
      </div>
    </ActionAfterViewObserver>
  );
};
